import { Stack, Text, Heading, Secondary } from '@kinesis/bungle';

type Props = {
  title: string;
  reason?: string;
  detail?: string;
};

const ConsentError = ({ title, reason, detail }: Props) => (
  <Stack space='small'>
    <Heading>{title}</Heading>
    {reason && <Text>{reason}</Text>}
    {detail && (
      <Text>
        <Secondary>{detail}</Secondary>
      </Text>
    )}
    <Text>
      <Secondary>
        If you reached this page from an application, you can close this tab or
        go back and try again. No access has been granted.
      </Secondary>
    </Text>
  </Stack>
);

export { ConsentError };
